import router from "@/router";

const user = {
  namespaced: true,
  state: {
    userInfo: {},
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit("setUserInfo", userInfo);
    },
    logout({ commit }) {
      localStorage.removeItem("dd-user-id");
      commit("setUserInfo", {});
      router.push({
        name: "SystemLogin",
        params: {
          redirect: router.currentRoute.fullPath,
        },
      });
    },
  },
};

export default user;
